import CopyToClipboard
  from 'views/atoms/CopyToClipboard/CopyToClipboard';

export default CopyToClipboard;
